import styles from './contact-details-page.module.scss';
import React, { useEffect, useState } from 'react';
import { ImArrowLeft } from 'react-icons/im';
import { useLocation, useNavigate } from 'react-router-dom';
import { PrimaryRoutes } from '../../../common/enums/internal-route-enums';
import Label from '../../atoms/Base/Label/Label';
import { useAppSelector } from '../../../redux/hooks';
import { StringHelper } from '../../../common/helpers/string-helper';
// import { Table } from 'react-bootstrap';
import Table from '../../atoms/Base/Table/Table';
import TableBody from '../../molecules/Base/TableBody/TableBody';
import TableHead from '../../molecules/Base/TableHead/TableHead';
import { ReferenceValueColumnName } from '../../../models/reference-value';
import { FieldType } from '../../../common/enums/field-type-enums';
import { Container } from '../../atoms/Base/Container/Container';
import { useActivityApiService } from '../../../api/providers/AppServiceProvider';
import { CXDATA_UNIQUE_CONTACT_KEY } from '../../../common/constants/contact-table-constants';
import CXDataLoader from '../../atoms/Custom/CXDataLoader/CXDataLoader';
import { DateHelper } from '../../../common/helpers/date-helper';

export default function ContactDetailsPage() {
	const navigate = useNavigate();
	const { state } = useLocation();
	const { contact } = state;

	const activityApiService = useActivityApiService();

	const cachedActivityColumnNames = useAppSelector((state) => state.activity.columnNames);
	const cachedContactColumnNames = useAppSelector((state) => state.contacts.columnNames);

	const [activityRows, setActivityRows] = useState<any[]>([]);
	const [isLoading, setIsLoading] = useState<boolean>(true);

	function formatDate(columnValue: string) {
		return DateHelper.GetFormattedDateTime(columnValue);
	}

	function formatActivityColumnValue(activityRow: any, activityColumnNameRef: ReferenceValueColumnName) {
		const columnValue = activityRow[activityColumnNameRef?.columnName];
		if (StringHelper.Capitalize(activityColumnNameRef.dataType) === FieldType.Date) {
			return formatDate(columnValue);
		}
		return columnValue;
	}

	function formatContactColumnValue(contactColumnNameRef: ReferenceValueColumnName) {
		const columnValue = contact[contactColumnNameRef?.columnName];
		if (StringHelper.Capitalize(contactColumnNameRef.dataType) === FieldType.Date) {
			return formatDate(columnValue);
		}
		return columnValue;
	}

	useEffect(() => {
		activityApiService.GetActivity(contact[CXDATA_UNIQUE_CONTACT_KEY]).then((response) => {
			setActivityRows(response);
			setIsLoading(false);
		});
	}, []);

	// Sort activity rows by date
	const sortedActivityRows = activityRows.sort((a, b) => {
		let dateA = new Date(a['INTERACTION_DATE']);
		let dateB = new Date(b['INTERACTION_DATE']);
		if (dateA.toString() == 'Invalid Date') {
			dateA = new Date(a['ORDER_CREATED_DATE']);
			dateB = new Date(b['ORDER_CREATED_DATE']);
		}
		return dateB.getTime() - dateA.getTime();
	});

	return (
		<div className={styles.contactDetails}>
			<div className={styles.contactDetailsContainer}>
				<div className={styles.detailsContainerOne}>
					<Container bottomSpace>
						<Label>Contact Profile</Label>
					</Container>
					<div className={styles.tableContainer}>
						<Table>
							<TableHead
								headings={['Property Name', 'Property Value']}
								headingOnly={false}
							/>
							<TableBody bodyOnly={false} rowCount={cachedContactColumnNames.length}>
								{cachedContactColumnNames.map((contactColumnName, index) => {
									var contactColumnNameRef = cachedContactColumnNames.find(
										(columnName) => columnName === contactColumnName
									)!;
									return (
										<tr key={index}>
											<td>
												{StringHelper.SnakeCaseToFriendlyString(
														contactColumnNameRef?.columnName
													)}
											</td>
											<td>
												{formatContactColumnValue(contactColumnNameRef)}
											</td>
										</tr>
									);
								})}
							</TableBody>
						</Table>
					</div>
				</div>
				<div className={styles.detailsContainerTwo}>
					<Container bottomSpace>
						<Label>Activity History</Label>
					</Container>
					<div className={styles.tableContainer}>
						<Table>
							{isLoading && (
								<TableBody bodyOnly={false} rowCount={1}>
									<tr>
										<td>
											<CXDataLoader />
										</td>
									</tr>
								</TableBody>
							)}
							{!isLoading && (
								<>
									<TableHead
										headings={[
											...cachedActivityColumnNames.map((activityColumnName) =>
												StringHelper.SnakeCaseToFriendlyString(activityColumnName.columnName)
											),
										]}
										headingOnly={false}
									/>
									<TableBody bodyOnly={false} rowCount={sortedActivityRows.length}>
										{sortedActivityRows.map((activityRow: any, index: number) => {
											return (
												<tr key={index}>
													{cachedActivityColumnNames.map((activityColumnName, index) => {
														var activityColumnNameRef = cachedActivityColumnNames.find(
															(columnName) => columnName === activityColumnName
														)!;
														return (
															<td key={index}>
																{formatActivityColumnValue(
																	activityRow,
																	activityColumnNameRef
																)}
															</td>
														);
													})}
												</tr>
											);
										})}
									</TableBody>
								</>
							)}
						</Table>
					</div>
				</div>
				<div className={styles.detailsContainerThree}></div>
			</div>
		</div>
	);
}